var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHierarchy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8457 5.15103C7.8457 5.7224 8.07268 6.27037 8.4767 6.67439C8.88072 7.07841 9.42869 7.30539 10.0001 7.30539C10.5714 7.30539 11.1194 7.07841 11.5234 6.67439C11.9274 6.27037 12.1544 5.7224 12.1544 5.15103C12.1544 4.57966 11.9274 4.03169 11.5234 3.62767C11.1194 3.22365 10.5714 2.99667 10.0001 2.99667C9.42869 2.99667 8.88072 3.22365 8.4767 3.62767C8.07268 4.03169 7.8457 4.57966 7.8457 5.15103V5.15103Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.92139 14.8456C1.92139 15.417 2.14836 15.965 2.55238 16.369C2.9564 16.773 3.50437 17 4.07574 17C4.64712 17 5.19508 16.773 5.5991 16.369C6.00313 15.965 6.2301 15.417 6.2301 14.8456C6.2301 14.2743 6.00313 13.7263 5.5991 13.3223C5.19508 12.9183 4.64712 12.6913 4.07574 12.6913C3.50437 12.6913 2.9564 12.9183 2.55238 13.3223C2.14836 13.7263 1.92139 14.2743 1.92139 14.8456V14.8456Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7705 14.8456C13.7705 15.417 13.9975 15.965 14.4015 16.369C14.8055 16.773 15.3535 17 15.9249 17C16.4962 17 17.0442 16.773 17.4482 16.369C17.8522 15.965 18.0792 15.417 18.0792 14.8456C18.0792 14.2743 17.8522 13.7263 17.4482 13.3223C17.0442 12.9183 16.4962 12.6913 15.9249 12.6913C15.3535 12.6913 14.8055 12.9183 14.4015 13.3223C13.9975 13.7263 13.7705 14.2743 13.7705 14.8456V14.8456Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.22998 14.8456H13.7702",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1914 6.94632L14.9845 12.9067",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80873 6.94632L5.01562 12.9067",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHierarchy);
export default __webpack_public_path__ + "static/media/Hierarchy.093ca9fe477a0efecc944b9332fe81f9.svg";
export { ForwardRef as ReactComponent };